import firebase from 'firebase/app'
import 'firebase/firestore'

firebase.initializeApp({
  projectId: 'roshults-planner',
  databaseURL: 'https://roshults-planner-test.firebaseio.com/',
  apiKey: 'AIzaSyAlNRdLrePSXg6VPRWAOhDWU0qf-pwauxQ',
})

 
export const db = firebase.firestore()